import { render } from "./Sellers.vue?vue&type=template&id=6bb42aaa"
import script from "./Sellers.vue?vue&type=script&lang=js"
export * from "./Sellers.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/megaluzz-admin/megaluzz-admin/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__